import api from './api';

const hotelService = {
  getAllHotels: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.accountid) params.append('accountid', filters.accountid);
    // partnerid scopes the list to hotels in chains belonging to the partner — used when no specific
    // chain is selected ("All Hotel Chains") so other partners' hotels are not returned.
    if (filters.partnerid) params.append('partnerid', filters.partnerid);
    if (filters.hotelname) params.append('hotelname', filters.hotelname);
    // The endpoint's own name/code search (hotel/list.js reads `search`). It was already being passed
    // by AdminSyncTaskForm and silently dropped here, so that screen's search only ever filtered the
    // page it had already loaded.
    if (filters.search) params.append('search', filters.search);
    if (filters.hotelcode) params.append('hotelcode', filters.hotelcode);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/hotel${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  getHotelById: async (id, accountid = null) => {
    const params = new URLSearchParams();
    if (accountid) params.append('accountid', accountid);
    const response = await api.get(`/hotel/${id}${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  createHotel: async (hotelData) => {
    // Clean up data: convert empty strings to null for optional fields
    const cleanedData = {
      ...hotelData,
      hotelcode: hotelData.hotelcode || null,
      CONTACTNAME: hotelData.CONTACTNAME || null,
      CONTACTPHONE: hotelData.CONTACTPHONE || null,
      CONTACTMOBILE: hotelData.CONTACTMOBILE || null,
      CONTACTEMAIL: hotelData.CONTACTEMAIL || null,
      COUNTRY: hotelData.COUNTRY || null,
      timezone: hotelData.timezone || null,
      CURRENCY: hotelData.CURRENCY || 'USD'
    };
    console.log('Creating hotel with data:', cleanedData);
    const response = await api.post('/hotel', cleanedData);
    return response.data;
  },

  updateHotel: async (id, hotelData) => {
    const response = await api.put(`/hotel/${id}`, hotelData);
    return response.data;
  },

  patchHotel: async (id, hotelData) => {
    const response = await api.patch(`/hotel/${id}`, hotelData);
    return response.data;
  },

  deleteHotel: async (id, accountid = null) => {
    const params = new URLSearchParams();
    if (accountid) params.append('accountid', accountid);
    const response = await api.delete(`/hotel/${id}${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  }
};

export default hotelService;
